import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueMoment from 'vue-moment'
import Notify from 'vue-notifyjs'
import ToggleButton from 'vue-js-toggle-button'

Vue.use(VueAxios, axios)
Vue.use(Vuex)
Vue.use(ToggleButton)

const moment = require('moment')
require('moment/locale/ru')

Vue.use(VueMoment, { moment });
Vue.use(Notify, {
    horizontalAlign: 'left',
    verticalAlign: 'top',
    timeout: 2000,
});

Vue.config.productionTip = false

Vue.filter('prepareApiStaticPath', function (path) {
    return process.env.VUE_APP_ROOT_API + path;
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')